import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Box, Button, Typography } from '@material-ui/core';
import { Business } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useAptorApi } from '../../../../../Api';
import { IOnboardingAccount } from '../../../../../Api/AptorApi';
import { Panel } from '../../../../../Components';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
import { useStyles } from './Onboarding.styles';

export const OnboardingAccounts = () => {
  const { api, abortController } = useAptorApi();
  const { formatMessage: t } = useIntl();
  const { onboardingCustomerId } = useContext(UserContext);
  const [accounts, setAccounts] = useState<IOnboardingAccount[]>();
  const [failed, setFailed] = useState(false);
  const [reload, setReload] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    if (onboardingCustomerId) return;
    setFailed(false);
    api.getOnboardingAccounts().then((result) => {
      if (!abortController.current.signal.aborted) setAccounts(result);
    }).catch(() => {
      if (!abortController.current.signal.aborted) setFailed(true);
    });
  }, [api, abortController, onboardingCustomerId, reload]);

  if (onboardingCustomerId || (!failed && !accounts?.length)) return null;
  const content = failed ? (
    <Alert severity="error" action={<Button onClick={() => setReload(reload + 1)}>{t({ id: 'onboarding.retry' })}</Button>}>
      {t({ id: 'utils.snackbar.somethingWentWrong' })}
    </Alert>
  ) : accounts?.map((account) => (
    <Box className={classes.account} key={account.customerId}>
      <Panel>
        <Box className={classes.heading}>
          <Avatar className={classes.avatar}><Business /></Avatar>
          <Typography variant="h4">{t({ id: 'onboarding.setup-title' })}</Typography>
        </Box>
        <Typography variant="h5">{account.customerName}</Typography>
        <Typography className={classes.details}>{t({ id: 'onboarding.assigned-to' })}: {account.assignedToName}</Typography>
        <Typography>{t({ id: 'onboarding.requested-by' })}: {account.createdByName}</Typography>
        <Typography color="textSecondary" className={classes.details}>{t({ id: 'onboarding.invitation-held' })}</Typography>
        <Box className={classes.actions}>
          <Button component={Link} to={`/law-portal/dashboard?setupCustomerId=${account.customerId}`} variant="contained" color="primary">
            {t({ id: account.step > 0 ? 'onboarding.continue' : 'onboarding.setup' })}
          </Button>
        </Box>
      </Panel>
    </Box>
  ));

  return <Box>{content}</Box>;
};
